module.exports = __webpack_public_path__ + "static/media/12.f5e3fffb.svg";